import { useMemo, useState } from "react";
import { DesktopCalendarView, MobileCalendarView, addDays, getDateRange } from "./calendarUtils";

export function useServiceCalendar(isMobile: boolean) {
  const [selectedDate, setSelectedDate] = useState(() => new Date());
  const [desktopView, setDesktopView] = useState<DesktopCalendarView>("week");
  const [mobileView, setMobileView] = useState<MobileCalendarView>("agenda");
  const activeRangeView = (isMobile ? mobileView : desktopView) === "month" ? "month" : "week";
  const range = useMemo(() => getDateRange(activeRangeView, selectedDate), [activeRangeView, selectedDate]);

  const navigate = (direction: "prev" | "next") => {
    setSelectedDate((current) => {
      const amount = direction === "next" ? 1 : -1;
      return activeRangeView === "month"
        ? new Date(current.getFullYear(), current.getMonth() + amount, 1)
        : addDays(current, amount * 7);
    });
  };

  return {
    selectedDate,
    desktopView,
    mobileView,
    rangeStart: range.start,
    rangeEnd: range.end,
    fromDate: range.fromDate,
    toDate: range.toDate,
    setSelectedDate,
    setDesktopView,
    setMobileView,
    navigate,
    goToToday: () => setSelectedDate(new Date()),
  };
}
